import { ticketViewService } from "../../services/merpservices";

export const fetchTicketData = async (empid, ak, glid, condition = '') => {
    try {
        const res = await ticketViewService(empid, ak,  glid, condition);
        if (res?.data?.status === 200) {
            return res.data.data;
        } else {
            return null;
        }
    } catch (error) {
        return null;
    }
}